/* Moneglia — interactions (revelation au scroll, quantite, guide, galerie, zoom) */
(function () {

  /* ---------- apparition au scroll ---------- */
  function reveal() {
    var els = [].slice.call(document.querySelectorAll('.mng-reveal:not(.is-in)'));
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -5% 0px' });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) el.classList.add('is-in'); else io.observe(el);
    });
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 5000);
  }

  /* ---------- quantite ---------- */
  function qty(root) {
    (root || document).querySelectorAll('.mng-qty').forEach(function (box) {
      if (box.dataset.bound) return;
      box.dataset.bound = '1';
      var input = box.querySelector('input');
      box.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.dataset.step === 'up' ? 1 : -1;
          var v = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- guide des tailles ---------- */
  function guide() {
    document.querySelectorAll('[data-mng-guide-open]').forEach(function (a) {
      if (a.dataset.bound) return;
      a.dataset.bound = '1';
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var d = document.getElementById('mng-guide');
        if (d && d.showModal) d.showModal();
      });
    });
    document.querySelectorAll('[data-mng-guide-close]').forEach(function (b) {
      if (b.dataset.bound) return;
      b.dataset.bound = '1';
      b.addEventListener('click', function () {
        var d = document.getElementById('mng-guide');
        if (d && d.close) d.close();
      });
    });
  }

  /* ---------- galerie produit + zoom ---------- */
  function gallery() {
    document.querySelectorAll('[data-mng-gallery]').forEach(function (gal) {
      if (gal.dataset.bound) return;
      gal.dataset.bound = '1';

      var track = gal.querySelector('[data-mng-gal-track]');
      if (!track) return;

      var slides  = [].slice.call(gal.querySelectorAll('[data-mng-gal-slide]'));
      var thumbs  = [].slice.call(gal.querySelectorAll('[data-mng-gal-thumb]'));
      var prev    = gal.querySelector('[data-mng-gal-prev]');
      var next    = gal.querySelector('[data-mng-gal-next]');
      var current = gal.querySelector('[data-mng-gal-current]');
      var index   = 0;

      function goTo(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }

      function setActive(i) {
        if (i === index) return;
        index = i;
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        if (current) current.textContent = i + 1;
        if (prev) prev.disabled = (i === 0);
        if (next) next.disabled = (i === slides.length - 1);
      }

      /* ----- visionneuse plein ecran ----- */
      var box   = gal.querySelector('[data-mng-zoom]');
      var stage = gal.querySelector('[data-mng-zoom-stage]');
      var zimg  = gal.querySelector('[data-mng-zoom-img]');
      var scale = 1, tx = 0, ty = 0, dragging = false, lastX = 0, lastY = 0;

      function apply() {
        zimg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
        box.classList.toggle('is-zoomed', scale > 1.02);
      }
      function resetZoom() { scale = 1; tx = 0; ty = 0; apply(); }

      function openZoom(i) {
        if (!box) return;
        var src = slides[i].getAttribute('data-full');
        if (!src) return;
        zimg.src = src;
        resetZoom();
        box.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        requestAnimationFrame(function () { box.classList.add('is-open'); });
      }
      function closeZoom() {
        if (!box) return;
        box.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        setTimeout(function () { box.hidden = true; resetZoom(); }, 260);
      }

      if (box) {
        var openBtn = gal.querySelector('[data-mng-zoom-open]');
        if (openBtn) openBtn.addEventListener('click', function () { openZoom(index); });
        slides.forEach(function (s, i) {
          s.addEventListener('click', function () { openZoom(i); });
        });

        gal.querySelector('[data-mng-zoom-close]').addEventListener('click', closeZoom);
        box.addEventListener('click', function (e) { if (e.target === box || e.target === stage) closeZoom(); });
        document.addEventListener('keydown', function (e) {
          if (box.hidden) return;
          if (e.key === 'Escape') closeZoom();
          if (e.key === 'ArrowRight' && index < slides.length - 1) { setActive(index + 1); goTo(index + 1); openZoom(index); }
          if (e.key === 'ArrowLeft'  && index > 0)                 { setActive(index - 1); goTo(index - 1); openZoom(index); }
        });

        stage.addEventListener('wheel', function (e) {
          e.preventDefault();
          var f = e.deltaY < 0 ? 1.14 : 1 / 1.14;
          scale = Math.min(4, Math.max(1, scale * f));
          if (scale === 1) { tx = 0; ty = 0; }
          apply();
        }, { passive: false });

        zimg.addEventListener('dblclick', function () {
          scale = scale > 1.02 ? 1 : 2.4;
          if (scale === 1) { tx = 0; ty = 0; }
          apply();
        });

        zimg.addEventListener('pointerdown', function (e) {
          if (scale <= 1.02) return;
          dragging = true; lastX = e.clientX; lastY = e.clientY;
          zimg.setPointerCapture(e.pointerId);
        });
        zimg.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          tx += e.clientX - lastX; ty += e.clientY - lastY;
          lastX = e.clientX; lastY = e.clientY;
          apply();
        });
        ['pointerup', 'pointercancel'].forEach(function (ev) {
          zimg.addEventListener(ev, function () { dragging = false; });
        });
      }

      if (slides.length < 2) { if (prev) prev.hidden = true; if (next) next.hidden = true; return; }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goTo(parseInt(t.dataset.index, 10) || 0); });
      });

      if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
        if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(index - 1); }
      });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && e.intersectionRatio > 0.55) setActive(slides.indexOf(e.target));
          });
        }, { root: track, threshold: [0.55, 0.8] });
        slides.forEach(function (s) { io.observe(s); });
      } else {
        track.addEventListener('scroll', function () {
          setActive(Math.round(track.scrollLeft / track.clientWidth));
        });
      }

      if (prev) prev.disabled = true;
    });
  }

  function init() { reveal(); qty(); guide(); gallery(); }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();
